import { c as _c } from "react-compiler-runtime";
import { useEffect } from "react";
export default function useOutsideClick(element, callback) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== callback || $[1] !== element) {
    t0 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const handleDocumentClick = event => {
        if (element && !element.contains(event.target as Node)) {
          callback(event);
        }
      };
      document.addEventListener("click", handleDocumentClick);
      return () => document.removeEventListener("click", handleDocumentClick);
    };
    t1 = [callback, element];
    $[0] = callback;
    $[1] = element;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}